import React, {useState, useEffect} from "react";
import {Link} from "react-router-dom";
import { isAuthenticated } from "./helper";
import AppTheme from "../colors";

const UpdateProfile = () => {
    const theme = JSON.parse(localStorage.getItem("theme"));
    const currentTheme =  AppTheme["light"]
    const {user, token } = isAuthenticated()
    const [name, setName] = useState(undefined)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)
    const [image, setImage] = useState("")
    const [url, setUrl] = useState(undefined)
    const [processing, setProcessing] = useState(false)
    const uploadPic = () => {
        setProcessing(true)
        const data = new FormData()
        data.append("file", image)
        data.append("upload_preset", "socioroorkee")
        data.append("cloud_name", "dhwaj")
        fetch("https://api.cloudinary.com/v1_1/dhwaj/image/upload", {
            method: "POST",
            body: data
        })
        .then(res => res.json())
        .then(data => {
            setUrl(data.secure_url)
            setProcessing(false)
        })
        .catch(err => console.log(err))
    }

    useEffect(() => {
        if(url){
            uploadFields()
        }
    }, [url])

    const uploadFields = () => {
        if(name === undefined && url == undefined){
            setError("Please write any of the fields")
        }
        
        else{
            if(name === undefined){
                setName(user.name);
                console.log(name);
            }
            setProcessing(true)
            fetch(`${process.env.REACT_APP_BACKEND}/user/${user._id}`, {
                method:"PUT",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    name,
                    pic: url
                })
            })
            .then(res => res.json())
            .then(data => {
                if(data.err){
                    setError(data.error);
                    setSuccess(false)
                    
                }
                else{
                    console.log(data);
                    var existing = JSON.parse(localStorage.getItem("jwt"));
                    existing.user.name = data.name;
                    existing.user.pic = data.pic;
                    localStorage.setItem("jwt", JSON.stringify(existing));
                    setName("");
                    setSuccess(true)
                    setProcessing(false)
                }
            })
            .catch(err => console.log(err))
        }
        
    }

    const PostData = () => {
        if(image){
            uploadPic() 
        }
        else{
            uploadFields()
        }
        
    }
    const successMessege = () => (
        <div className="row">
            <div className="col s12 center-align">
                <div className="card-panel green white-text" style={{display: success ? "" : "none"}}>
                    Profile has been updated successfully
                </div>
            </div>
        </div>
        
    )
    const errorMessege = () => (
        <div className="row">
            <div className="col s12 center-align">
                <div className="card-panel red white-text" style={{display: error ? "" : "none"}}>
                    {error}
                </div>
            </div>
        </div>
    )
    return (
        <div className="row" >
            <div className="col s12">
                <div className="mycard" >
            
                <div className="card auth-card input-field" style={{backgroundColor: `${currentTheme.navColor}`, color: `${currentTheme.textColor}`}}>
                    {successMessege()}
                    {errorMessege()}
                    <h2 style={{color: `${currentTheme.textColor}`}}>Update Profile</h2>
                    <input type="text" placeholder="name" value={name} onChange={(e) => setName(e.target.value)} style={{color: `${currentTheme.textColor}`}}/>
                    <div className="file-field input-field">
                        <div className="btn #64b5f6 blue darken-1">
                            <span>Upload Pic</span>
                            <input type="file" onChange={e => setImage(e.target.files[0])} />
                        </div>
                        <div className="file-path-wrapper"> 
                            <input className="file-path validate" type="text"/>
                        </div>
                    </div>
                    <button className="btn waves-effect waves-light #64b5f6 blue darken-1" onClick={PostData}>
                        {processing ? 'Updating...' : 'Update'}
                    </button>
                    <h5><Link to="/profile" ><span style={{color: `${currentTheme.textColor}`}}>Back</span></Link></h5>
                </div>
            </div>
            </div>
        </div>
        
    )
}

export default UpdateProfile;